module.exports = __webpack_public_path__ + "static/media/video_img_02.d909bfe0.jpg";